// extracted by mini-css-extract-plugin
export default {"stripeElements":"csih62e9pUgofPeWIZO7"};